export type FirebaseWebConfig = {
	apiKey: string;
	authDomain: string;
	projectId: string;
	storageBucket: string;
	messagingSenderId: string;
	appId: string;
};

export function getFirebaseWebConfig(): FirebaseWebConfig | null {
	const apiKey = process.env.NEXT_PUBLIC_FIREBASE_API_KEY?.trim();
	const authDomain = process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN?.trim();
	const projectId = process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID?.trim();
	const storageBucket = process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET?.trim();
	const messagingSenderId = process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID?.trim();
	const appId = process.env.NEXT_PUBLIC_FIREBASE_APP_ID?.trim();

	if (!apiKey || !authDomain || !projectId || !messagingSenderId || !appId) {
		return null;
	}

	return {
		apiKey,
		authDomain,
		projectId,
		storageBucket: storageBucket ?? `${projectId}.appspot.com`,
		messagingSenderId,
		appId,
	};
}

export function getFirebaseVapidKey(): string | null {
	const key = process.env.NEXT_PUBLIC_FIREBASE_VAPID_KEY?.trim();
	return key && key.length > 0 ? key : null;
}

export function isWebPushConfigured(): boolean {
	return getFirebaseWebConfig() != null && getFirebaseVapidKey() != null;
}
